import React, { useState, useEffect } from "react";
import { Text } from "../../formitems/Index";
import { LeftOutlined } from "@ant-design/icons";
import dateFormat from "dateformat";
import { Select } from "antd";
import DatePicker from "react-datepicker";
import moment from "moment";
import Iframe from "react-iframe";
const EditQualifications = ({
  close,
  data,
  datas,
  UpdateQualication,
  UpdateQualicationDeactivate,
}) => {
  const q_data = data?.aatmsv4_qualificationrecords[0];
  const [Formdata, setFormdata] = useState({ ...q_data });
  const time = moment(Formdata?.issuedate).format("YYYY/MM/DD");
  const issueDate = new Date(time);
  const dates = moment(Formdata?.validdate).format("YYYY/MM/DD");
  const vaidDate = new Date(dates);
  const handleFormFields = (v, fieldName) => {
    switch (fieldName) {
      case "documentnumber":
        setFormdata({ ...Formdata, documentnumber: v });
        break;
      case "issuingauthority":
        setFormdata({ ...Formdata, issuingauthority: v });
        break;
      case "data1":
        setFormdata({ ...Formdata, data1: v });
        break;
      case "data2":
        setFormdata({ ...Formdata, data2: v });
        break;
      case "data3":
        setFormdata({ ...Formdata, data3: v });
        break;
      case "issuedate":
        setFormdata({ ...Formdata, issuedate: v });
        break;
      case "validdate":
        setFormdata({ ...Formdata, validdate: v });
        break;
      case "validated":
        setFormdata({ ...Formdata, validated: v });
        break;
      case "active":
        setFormdata({ ...Formdata, active: v });
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    setFormdata({ ...q_data });
  }, [q_data]);
  const Option = Select.Option;
  return (
    <div className="qualificationPage">
      <div>
        <div className="addQualification__form qualificationPage__left">
          <div className="addQualification__form--title">
            <span className="client-back" onClick={() => close()}>
              {<LeftOutlined />} Qualifications
            </span>
            Edit Qualification Record
          </div>
          <h4>
            <b>Qualification Details:</b>
          </h4>
          <Text title="Name" value={q_data?.crew?.name} disabled />
          <Text title="Q-Code" value={q_data?.qcode} disabled />
          <Text title="Qualification" value={q_data?.qualification} disabled />
          <Text
            title="Document Number"
            value={Formdata?.documentnumber}
            onChange={(e) => handleFormFields(e.target.value, "documentnumber")}
          />
          <Text
            title="Issuing-Authority"
            value={Formdata?.issuingauthority}
            onChange={(e) =>
              handleFormFields(e.target.value, "issuingauthority")
            }
          />
          <Text
            title={q_data?.caption1}
            value={Formdata?.data1}
            onChange={(e) => handleFormFields(e.target.value, "data1")}
          />
          <Text
            title={q_data?.caption2}
            value={Formdata?.data2}
            onChange={(e) => handleFormFields(e.target.value, "data2")}
          />
          <Text
            title={q_data?.caption3}
            value={Formdata?.data3}
            onChange={(e) => handleFormFields(e.target.value, "data3")}
          />
          <h4>
            <b>Issue date & validity:</b>
          </h4>
          <DatePicker
            selected={issueDate}
            onChange={(date) =>
              handleFormFields(dateFormat(date, "isoDate"), "issuedate")
            }
          />
          <br />
          <br />
          <DatePicker
            selected={vaidDate}
            onChange={(date) =>
              handleFormFields(dateFormat(date, "isoDate"), "validdate")
            }
          />
          <br />
          <br />
          <h4>
            <b>Document Status:</b>
          </h4>
          <div>Validate:</div>
          <Select
            value={Formdata?.validated === true ? "Yes" : "No"}
            onChange={(e) => handleFormFields(e, "validated")}
          >
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>
          </Select>
          <div>Active:</div>
          <Select
            value={Formdata?.active === true ? "Yes" : "No"}
            onChange={(e) => handleFormFields(e, "active")}
          >
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>
          </Select>
          <button
            className="submit-button"
            onClick={() => {
              UpdateQualication({
                variables: {
                  active: Formdata?.active,
                  valid: Formdata?.validated,
                  date2: Formdata?.validdate,
                  date: Formdata?.issuedate,
                  id: datas,
                  document: Formdata?.documentnumber,
                  issue: Formdata?.issuingauthority,
                  data1: Formdata?.data1,
                  data2: Formdata?.data2,
                  data3: Formdata?.data3,
                },
              });
              close();
            }}
          >
            Edit & Validate
          </button>
          <button
            className="submit-button"
            style={{ backgroundColor: "crimson" }}
            onClick={() => {
              UpdateQualicationDeactivate({
                variables: {
                  active: Formdata?.active,
                  valid: Formdata?.validated,
                  date2: Formdata?.validdate,
                  date: Formdata?.issuedate,
                  id: datas,
                  document: Formdata?.documentnumber,
                  issue: Formdata?.issuingauthority,
                  data1: Formdata?.data1,
                  data2: Formdata?.data2,
                  data3: Formdata?.data3,
                },
              });
              close();
            }}
          >
            Edit & De-activate
          </button>
          <button className="cancel-button" onClick={() => close()}>
            Exit
          </button>
        </div>
      </div>
      <div className="qualificationPage__right">
        {q_data?.document ? (
          <Iframe
            url={q_data.document}
            id="pdfId"
            className="pdfClassname"
            display="initial"
            position="relative"
          />
        ) : null}
      </div>
      {/* <div style={{ width: "50%" }}>
        <img
          style={{
            width: "100%",
            height: "97%",
            marginTop: "68px",
            borderRadius: "25px",
          }}
          src={q_data?.document}
          alt=""
        />
      </div> */}
    </div>
  );
};
export default EditQualifications;
